var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @ts-check
import { Task } from '@lit/task';
import '@shoelace-style/shoelace';
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { SHARED_STYLES } from '../css/shared-css.js';
import './chromedash-report-spec-mentor.js';
import { isoDateString } from './utils.js';
let ChromedashReportSpecMentorsPage = class ChromedashReportSpecMentorsPage extends LitElement {
    constructor() {
        super(...arguments);
        this.rawQuery = {};
        this._client = window.csOpenApiClient;
        this._mentorsTask = new Task(this, {
            task: async ([updatedAfter], { signal }) => {
                const mentors = await this._client.listSpecMentors({ after: updatedAfter }, { signal });
                mentors.sort((a, b) => a.email.localeCompare(b.email));
                return mentors;
            },
            args: () => [this._updatedAfter],
        });
        this._updatedAfter = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000);
    }
    static get styles() {
        return [...SHARED_STYLES, css ``];
    }
    connectedCallback() {
        super.connectedCallback();
        this.initializeParams();
    }
    initializeParams() {
        if (!this.rawQuery) {
            return;
        }
        if (this.rawQuery['after']) {
            const parsed = Date.parse(this.rawQuery['after']);
            if (!isNaN(parsed)) {
                this._updatedAfter = new Date(parsed);
            }
        }
    }
    afterChanged(e) {
        e.stopPropagation();
        const newDate = e.target.valueAsDate;
        if (newDate) {
            this._updatedAfter = newDate;
            this.dispatchEvent(new CustomEvent('afterchanged', {
                detail: { after: this._updatedAfter },
                bubbles: true,
                composed: true,
            }));
        }
    }
    render() {
        return html `
      <div id="subheader">
        <sl-input
          type="date"
          name="after"
          value=${isoDateString(this._updatedAfter)}
          label="List spec mentors who've worked on features that were updated after this date"
          @sl-change=${this.afterChanged}
        ></sl-input>
      </div>
      ${this._mentorsTask.render({
            pending: () => html ` <details open>
            <summary><sl-skeleton effect="sheen"></sl-skeleton></summary>
            <sl-skeleton effect="sheen"></sl-skeleton>
          </details>`,
            complete: specMentors => specMentors.map(mentor => html `<chromedash-report-spec-mentor
                .mentor=${mentor}
              ></chromedash-report-spec-mentor>`),
            error: e => {
                console.error(e);
                return html `<p>
            Some errors occurred. Please refresh the page or try again later.
          </p>`;
            },
        })}
    `;
    }
};
__decorate([
    property({ type: Object })
], ChromedashReportSpecMentorsPage.prototype, "rawQuery", void 0);
__decorate([
    property({ attribute: false })
], ChromedashReportSpecMentorsPage.prototype, "_client", void 0);
__decorate([
    property({ attribute: false })
], ChromedashReportSpecMentorsPage.prototype, "_mentorsTask", void 0);
__decorate([
    state() // Default to a year ago.
], ChromedashReportSpecMentorsPage.prototype, "_updatedAfter", void 0);
ChromedashReportSpecMentorsPage = __decorate([
    customElement('chromedash-report-spec-mentors-page')
], ChromedashReportSpecMentorsPage);
export { ChromedashReportSpecMentorsPage };
